// extracted by mini-css-extract-plugin
export default {"bigLoader":"BigLoader_bigLoader__vgW5S"};